<!-- title -->
<template>
  <div :class="blue?'color-blue':''||black?'color-black':''"
       class="base-note"
       :noMargin="isSingleText?'noMargin':''">
    {{title}}
    <ul class="note"
        :class="noNum?'note-before':''"
        :noMargin="isSingleText?'noMargin':''">
      <li v-if="isSingleText">
        <slot></slot>
      </li>
      <!-- :key="index">{{noteText}}</li> -->
      <li v-else
          v-for="(noteText, index) in noteItems"
          :key="index"><span v-html="noteText"></span></li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'base-note',

  props: {
    noNum: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    noteItems: {
      type: Array,
      default: function () {
        return []
      }
    },
    blue: {
      type: Boolean,
      default: false
    },
    black: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    isSingleText () {
      return !!this.$slots.default
    }
  }
}
</script>
<style lang="stylus" scoped>
.base-note {
  color: red;
  font-size: $font-size !important;
  text-align: justify;
  margin: 10px 30px 30px;
}

.base-note[noMargin='noMargin'] {
  margin: 0px;
}

.note {
  list-style-type: decimal;
  text-align: justify
}

.note[noMargin='noMargin'] {
  margin: 0px;
}

&.note-before {
  list-style-type: none;
  padding-left: 0px;

  li {
    margin-left: 23px;
  }
}

&.note-before>*:before {
  content: '※';
  padding: 0 5px;
  margin-left: -23px;
}

.color-blue {
  color: $accent-color-A;

  .note {
    color: $accent-color-A;
  }
}
.color-black {
  color: black;

  .note {
    color: black;
  }
}
</style>
